<template>
  <div>

    <div class="container">

      <div class="content-wrapper">
        <img class="hero-pic" src="../assets/life-ring-1.jpg" alt="How It Works">
        <h1>How it works</h1>
        <h4>Instructions on how to use this tutorial and what you need to do.</h4>
        <p>
          <router-link class="button is-primary" to="Tutorial">Start Tutorial</router-link>
        </p>
      </div>

    </div>

  </div>


</template>

<script>
// @ is an alias to /src

export default {
  name: 'HowItWorks',
  methods: {

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

  }
}
</script>


<style lang="scss" scoped> 

  h1 {
    margin: 1rem auto 2rem;
    color: #06c;
  }
  h4 {
    margin-bottom: 2rem;
  }
  img {
    &.hero-pic {
      max-width: 280px;
    }
  }

</style>
